var map = {
	"./404.svg": "a14a",
	"./about-h.svg": "8eab",
	"./about.svg": "a85b",
	"./alipay.svg": "2287",
	"./avatar.svg": "bec7",
	"./bailianhua.svg": "466d",
	"./bless-h.svg": "765e",
	"./bless.svg": "50c7",
	"./choose.svg": "720a",
	"./clock.svg": "4c09",
	"./deng-h.svg": "790e",
	"./deng.svg": "19ff",
	"./dianji.svg": "4190",
	"./donate-h.svg": "7b24",
	"./donate.svg": "6ba6",
	"./home-h.svg": "2961",
	"./home.svg": "6bbe",
	"./kuang-h.svg": "1705",
	"./kuang.svg": "a3b0",
	"./lianhua.svg": "4914",
	"./lock.svg": "ab00",
	"./me-h.svg": "5d74",
	"./me.svg": "f894",
	"./meal-h.svg": "fc6e",
	"./meal.svg": "2d0b",
	"./message.svg": "47ff",
	"./mine.svg": "e8d1",
	"./order.svg": "11ff",
	"./pavilion.svg": "5b32",
	"./sc.svg": "ba53",
	"./success.svg": "a8cf",
	"./wechatpay.svg": "22a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";